export const LOREN_PATH_PARAMS = {
    userId: ':userId'
};
